import { VersionLink } from 'modules/versioning'
import styled, { css } from 'styled-components'
import { Flex } from 'components/Box'
import { tabStyle } from 'components/Tabs/Tab'
import Button from 'components/Button'
import Filter from 'components/Filter'
import { breakpoint } from 'utils'

export const TopNavigationList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
`

export const TopNavigationLink = styled(VersionLink)<{ selected: boolean }>`
  ${tabStyle}
  margin-right: 0;
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  padding: 8px 8px;

  /* This is needed to avoid the navigation going over the right sidebar */
  @media (min-width: 830px) {
    padding: 8px 12px;
  }

  ${breakpoint('lg')`
    margin-right: 8px;
  `};
`

export const Container = styled(Flex)<{ isSidebarRightOpen: boolean }>(
  ({ theme, isSidebarRightOpen }) => css`
    position: fixed;
    top: ${theme.header.height + 1}px;
    height: auto;
    background-color: ${theme.colors.background.secondary[1]};
    z-index: 1;
    justify-content: space-between;
    box-shadow: ${theme.shadows.boxShadow.subtle};
    border-bottom: 1px solid ${theme.colors.border[2]};
    padding-right: 12px;
    padding-left: 12px;
    width: ${isSidebarRightOpen
      ? `calc(100% - ${theme.sidebar.rightWidth}px)`
      : '100%'};
    transition-timing-function: ease-in-out;
    transition-duration: 0.3s;
    transition-property: width;
    will-change: width;
  `
)

export const MobileContainer = styled(Container)<{
  isSidebarRightOpen: boolean
}>(
  ({ isSidebarRightOpen }) => css`
    width: 100%;
    height: 56px;
    left: 0;
    padding-left: 12px;

    ${breakpoint('sm')`
        width: ${isSidebarRightOpen ? 'calc(100% - 350px)' : '100%'};
        transition-timing-function: ease-in-out;
        transition-duration: 0.3s;
        transition-property: width;
        will-change: width;
  `};
  `
)

export const SearchContainer = styled.div`
  width: 300px;
  display: none;

  /* Search overwrites */
  input[type='text'] {
    background: white;
    padding-right: 32px;
  }

  ${breakpoint('lg')`
     display: block
  `};
`

export const MobileNavigationLink = styled(VersionLink)<{ selected: boolean }>`
  ${tabStyle}
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  text-align: left;
  font-weight: normal;

  &:first-of-type {
    margin-top: 8px;
  }
`

export const MobileNavigationHeader = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary[4]};
    font-weight: ${theme.fontWeights.semibold};
    font-size: ${theme.fontSizes.tiny};
    text-transform: uppercase;
    margin-left: 8px;
    margin-top: 12px;
  `
)

export const MobileSearchContainer = styled.div<{
  isSearchVisible: boolean
  ref?: any
}>(
  ({ isSearchVisible }) => css`
    position: relative;
    min-width: ${isSearchVisible ? '190px' : '40px'};
    width: ${isSearchVisible ? '100%' : '40px'};
    margin-right: 16px;
    transition-timing-function: ease-in-out;
    transition-duration: 0.3s;
    transition-property: min-width, width;
    will-change: min-width, width;
  `
)

export const MobileSearchButton = styled(Button)<{ isSearchVisible: boolean }>(
  ({ isSearchVisible }) => css`
    z-index: 50;
    opacity: ${isSearchVisible ? 0 : 1};
    width: 40px;
    text-align: center;
    transition-timing-function: ease-in-out;
    transition-duration: 0.3s;
    transition-property: opacity;
    will-change: opacity;

    svg {
      margin-left: 8px;
    }
  `
)

export const MobileSearch = styled(Filter)<{ isSearchVisible: boolean }>(
  ({ isSearchVisible }) => css`
    position: absolute;
    top: 0;
    left: 0;
    height: 40px;
    transition-timing-function: ease-in-out;
    transition-duration: 0.3s;
    transition-property: opacity;
    will-change: opacity;
    opacity: ${isSearchVisible ? 1 : 0};
  `
)
